export default __webpack_public_path__ + "static/media/onePlusLogo.4a1fc5bb.svg";